<template>
  <div id="app">
    <!-- <router-link :to="{ name: 'home', props: {calcData} }">Test</router-link> -->
      <router-view :calcData="calcData"/>
    <!-- </home v-bind:calcData="calcData"> -->
  </div>
</template>


<!-- ==========================  JAVASCRIPT BELOW  ==================================== -->

<script>
export default {
  data: function () {
    return {
      calcData:
        {


          errorMessage: "",

          allMembServ:0,
          allServCredit:0,
          annsalary:0,
          at_age: null,
          at_scyears: '',
          at_termdate: null,
          beneage: 0,
          beneage_at_ret: 0,
          benedob: null,
          checkedOption: 'T',
          chkspouse: true,
          curPage: 1,
          disp_effdate: new Date(),
          drawBeyond: '',
          erf: 0,
          firstName: '',
          hac:0,
          benedob: null,
          // disp_hiredate: null,
          hiredate: null,
          isError: false,
          lastName: '',
          memberage: 0,
          memberage_at_ret: 0,
          memberdob: null,
          msMonths : 0,
          msMonthsPurchase: 0,
          msYears : 0,
          msYearsPurchase: 0,
          msDecimal:0,
          msDecimalPurchase:0,
          multiplier:0,
          noedit: true,
          ok: true,
          opt1: 0,
          opt2: 0,
          opt3: 0,
          opt410: 0,
          opt420: 0,
          optFactor: 0,
          perIncrease: '0.0',
          pers: true,
          retDate: null,
          retsys: 'PERS',
          retTypeDescription:'',
          scMonths:0,
          scMonthsPurchase: 0,
          scYears: 0,
          scDecimal:0,
          scDecimalPurchase:0,
          scYearsPurchase: 0,
          totServCredit:0,
          totMembServ:0,

          curServCredit:0,
          curMembServ:0,
          asOfAge:0,
          yearsToRet:0

          // annsalary:90000,
          // at_age: '65',
          // checkedOption: 'A',
          // benedob: new Date('11-9-1962'),
          // hiredate: new Date('05-10-2010'),
          // memberdob: new Date('3-5-1963'),
          // msMonths : 1,
          // msMonthsPurchase: 10,
          // msYears :12,
          // msYearsPurchase: 4,
          // scMonths:10,
          // scMonthsPurchase: 10,
          // scYears:11,
          // scDecimal:0,
          // scDecimalPurchase:0,
          // scYearsPurchase: 4
        }
    }
  },
};
</script>
